// src/entities/authorComposer/components/common/AuthorStatusCell.tsx
import React from "react";
import { observer } from "mobx-react";
import { Box, Tooltip } from "@mui/material";
import { CheckCircleIcon, WarningAmberIcon } from "../../../../icons";
import { useRootStore } from "../../../../store/contexts";
import { tieneDatosValidados, useEstadoAutor } from "./authorStatus";
import { avisosDeDocumentacion } from "./AuthorDocumentationWarning";

/** La celda del listado: el tic de "Datos validados con DNI" y el ícono de advertencia, con su texto. */
export const AuthorStatusCell: React.FC<{ authorId: string }> = observer(({ authorId }) => {
  const { langStore } = useRootStore();
  const estado = useEstadoAutor(authorId);
  const avisos = avisosDeDocumentacion(estado, langStore).join(" ");
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      {tieneDatosValidados(estado) && (
        <Tooltip title={langStore.authorDniValidatedRecord}>
          <Box component="span" role="img" aria-label={langStore.authorDniValidatedRecord} sx={{ display: "inline-flex" }}>
            <CheckCircleIcon color="success" fontSize="small" />
          </Box>
        </Tooltip>
      )}
      {avisos && (
        <Tooltip title={avisos}>
          <Box component="span" role="img" aria-label={avisos} sx={{ display: "inline-flex" }}>
            <WarningAmberIcon color="warning" fontSize="small" />
          </Box>
        </Tooltip>
      )}
    </Box>
  );
});
